<template>
  <section class="section-container" v-if="is_administrator">
    <div class="content-wrapper">
      <div class="content-heading">
        {{ $t('notificationsettings.settings') }}
      </div>
      <div class="row">
        <div class="col-xl-4 col-sm-6 col-12">
          <div class="card card-default">
            <div class="card-body">
              <div class="form-group">
                <label for="company_name">{{ $t('notificationsettings.company-name') }} *</label>
                <input
                  :class="{'parsley-error': errors.company_name}"
                  autocomplete="off"
                  class="form-control"
                  id="company_name"
                  :placeholder="$t('notificationsettings.insert-company-name')"
                  type="text"
                  v-model="email.company_name">
                <ul class="parsley-errors-list filled" v-if="errors.company_name">
                  <li class="parsley-required">{{ errors.company_name[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="from_name">{{ $t('notificationsettings.from-name') }} *</label>
                <input
                  :class="{'parsley-error': errors.from_name}"
                  autocomplete="off"
                  class="form-control"
                  id="from_name"
                  :placeholder="$t('notificationsettings.insert-from-name')"
                  type="text"
                  v-model="email.from_name">
                <ul class="parsley-errors-list filled" v-if="errors.from_name">
                  <li class="parsley-required">{{ errors.from_name[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="company_phone">{{ $t('notificationsettings.company-phone') }} *</label>
                <input
                  :class="{'parsley-error': errors.company_phone}"
                  autocomplete="off"
                  class="form-control"
                  id="company_phone"
                  :placeholder="$t('notificationsettings.insert-company-phone')"
                  type="text"
                  v-model="email.company_phone">
                <ul class="parsley-errors-list filled" v-if="errors.company_phone">
                  <li class="parsley-required">{{ errors.company_phone[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="logo_path">{{ $t('notificationsettings.logo-path') }} *</label>
                <input
                  :class="{'parsley-error': errors.logo_path}"
                  autocomplete="off"
                  class="form-control"
                  id="logo_path"
                  :placeholder="$t('notificationsettings.insert-logo-path')"
                  type="text"
                  v-model="email.logo_path">
                <ul class="parsley-errors-list filled" v-if="errors.logo_path">
                  <li class="parsley-required">{{ errors.logo_path[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="company_email">{{ $t('notificationsettings.feedback-email') }} *</label>
                <input
                  :class="{'parsley-error': errors.company_email}"
                  autocomplete="off"
                  class="form-control"
                  id="company_email"
                  :placeholder="$t('notificationsettings.insert-feedback-email')"
                  type="text"
                  v-model="email.company_email">
                <ul class="parsley-errors-list filled" v-if="errors.company_email">
                  <li class="parsley-required">{{ errors.company_email[0] }}</li>
                </ul>
              </div>

              <hr>

              <div class="form-group">
                <label for="smtp_username">{{ $t('notificationsettings.smtp-username') }} *</label>
                <input
                  :class="{'parsley-error': errors.smtp_username}"
                  autocomplete="off"
                  class="form-control"
                  id="smtp_username"
                  :placeholder="$t('notificationsettings.insert-smtp-username')"
                  type="text"
                  v-model="email.smtp_username">
                <ul class="parsley-errors-list filled" v-if="errors.smtp_username">
                  <li class="parsley-required">{{ errors.smtp_username[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="smtp_password">{{ $t('notificationsettings.smtp-password') }} *</label>
                <input
                  :class="{'parsley-error': errors.smtp_password}"
                  autocomplete="off"
                  class="form-control"
                  id="smtp_password"
                  :placeholder="$t('notificationsettings.insert-smtp-password')"
                  type="password"
                  v-model="email.smtp_password">
                <ul class="parsley-errors-list filled" v-if="errors.smtp_password">
                  <li class="parsley-required">{{ errors.smtp_password[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="from_email">{{ $t('notificationsettings.from-email') }} *</label>
                <input
                  :class="{'parsley-error': errors.from_email}"
                  autocomplete="off"
                  class="form-control"
                  id="from_email"
                  :placeholder="$t('notificationsettings.insert-from-email')"
                  type="text"
                  v-model="email.from_email">
                <ul class="parsley-errors-list filled" v-if="errors.from_email">
                  <li class="parsley-required">{{ errors.from_email[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="smtp_server">{{ $t('notificationsettings.smtp-server') }} *</label>
                <input
                  :class="{'parsley-error': errors.smtp_server}"
                  autocomplete="off"
                  class="form-control"
                  id="smtp_server"
                  :placeholder="$t('notificationsettings.insert-smtp-server')"
                  type="text"
                  v-model="email.smtp_server">
                <ul class="parsley-errors-list filled" v-if="errors.smtp_server">
                  <li class="parsley-required">{{ errors.smtp_server[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="smtp_port">{{ $t('notificationsettings.smtp-port') }} *</label>
                <input
                  :class="{'parsley-error': errors.smtp_port}"
                  autocomplete="off"
                  class="form-control"
                  id="smtp_port"
                  :placeholder="$t('notificationsettings.insert-smtp-port')"
                  type="text"
                  v-model="email.smtp_port">
                <ul class="parsley-errors-list filled" v-if="errors.smtp_port">
                  <li class="parsley-required">{{ errors.smtp_port[0] }}</li>
                </ul>
              </div>

              <div class="form-group">
                <label for="admin_email">{{ $t('notificationsettings.notifications-email') }} *</label>
                <input
                  :class="{'parsley-error': errors.admin_email}"
                  autocomplete="off"
                  class="form-control"
                  id="admin_email"
                  :placeholder="$t('notificationsettings.insert-email')"
                  type="text"
                  v-model="email.admin_email">
                <ul class="parsley-errors-list filled" v-if="errors.admin_email">
                  <li class="parsley-required">{{ errors.admin_email[0] }}</li>
                </ul>
              </div>

              <hr>

              <div class="text-right">
                <router-link :to="{name: 'notifications'}" class="btn btn-sm btn-secondary wd-xs" type="submit">
                  <span>{{ $t('notificationsettings.cancel') }}</span>
                </router-link>
                <button class="btn btn-sm btn-outline-success wd-xs" @click="test">{{ $t('notificationsettings.test') }}</button>
                <button class="btn btn-sm btn-success wd-xs" @click="save">{{ $t('notificationsettings.save') }}</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import message from '@/message'
import {parseApiError} from '@/utils'

const getData = (next) => {
  Promise.all([
    api.get(`/emails/1/`)
  ])
    .then(([email]) => {
      next({
        email: email.data
      })
    })
}

export default {
  computed: {
    is_administrator() {
      return this.$store.getters.user_group === 'Administrator'
    }
  },
  mounted () {
    this.$parent.menu = 'notifications'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  data () {
    return {
      email: {},
      errors: {}
    }
  },
  methods: {
    test () {
      api.post('/test_smtp/')
        .then(resp => {
          if (resp.data === 'OK') {
            message.success('Emails settings are correct!')
          } else {
            message.error('Wrong emails settings!')
          }
        })
        .catch(error => {
          let errors = parseApiError(error, this.$i18n)
          if (error.response && error.response.status === 400) {
            this.errors = errors
          } else {
            message.error(errors)
          }
        })
    },
    save () {
      this.errors = {}
      api.patch('/emails/1/', this.email)
        .then(() => {
          message.success('Email settings updated')
        })
        .catch(error => {
          let errors = parseApiError(error, this.$i18n)
          if (error.response && error.response.status === 400) {
            this.errors = errors
          } else {
            message.error(errors)
          }
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Notificationsettings.vue